module.exports = __webpack_public_path__ + "static/img/02bg2.6c66aba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/report/03month/02bg2.png
// module id = j8nJ
// module chunks = 0